// Canonical API error classes for the client-api browser HTTP boundary.
//
// These are the single class definitions for CMx API errors. Callers that need
// to catch them with `instanceof` MUST import them from `@codametrix/client-api`
// so error identity stays consistent across package boundaries.

export interface CMxFormErrors {
  status: string;
  message: string;
  errors: string[];
  fieldErrors: Record<string, string[]>;
}

export interface CMxError {
  response: Response;
  errors: CMxFormErrors;
}

class FormSubmissionError extends Error implements CMxError {
  response: Response;
  errors: CMxFormErrors;

  constructor(message: string, response: Response, errors: CMxFormErrors) {
    super(message);
    this.response = response;
    this.errors = errors;
  }
}

class UnauthenticatedError extends Error {}

class ServerError extends Error {}

class PageNotFoundError extends Error {
  errors: CMxFormErrors;

  constructor(message: string) {
    super(message);

    const errors: CMxFormErrors = {
      status: 'PAGE NOT FOUND',
      message,
      errors: [message],
      fieldErrors: {}
    };

    this.errors = errors;
  }
}

class BadRequestError extends FormSubmissionError {}

export {
  FormSubmissionError,
  UnauthenticatedError,
  ServerError,
  PageNotFoundError,
  BadRequestError
};
